import e from"react";import r from"../../../external/classnames/index.js";const a=a=>{const{children:t,className:s="primary"}=a,m=r("tag",s);return e.createElement("div",{className:m},t)};export{a as Tag};
//# sourceMappingURL=Tag.js.map
